/** กล่องงานของฉัน (D-183): เอกสารที่รอฉันอนุมัติ + เรื่องที่ต้องใส่ใจตอนนี้ — โหลดไม่ได้ = ไม่แสดงอะไร (ไม่รบกวนหน้าแรก) */

import { useEffect, useState } from 'react';

import { Link } from 'react-router-dom';

import { fetchRecords, type RecordRow } from '../lib/backend/records';
import { RecordTable } from './components/RecordTable';

export interface InboxPanelProps {
  readonly apiBaseUrl?: string;
  readonly fetchImpl?: typeof fetch;
}

export function InboxPanel({ apiBaseUrl, fetchImpl }: InboxPanelProps) {
  const [approvals, setApprovals] = useState<readonly RecordRow[]>([]);
  const [notifications, setNotifications] = useState<readonly RecordRow[]>([]);

  useEffect(() => {
    let cancelled = false;
    const io = {
      ...(apiBaseUrl === undefined ? {} : { apiBaseUrl }),
      ...(fetchImpl === undefined ? {} : { fetchImpl }),
    };
    void (async () => {
      const [a, n] = await Promise.all([fetchRecords('/v1/approvals', {}, io), fetchRecords('/v1/notifications', {}, io)]);
      if (cancelled) {
        return;
      }
      setApprovals(a.status === 'ready' ? a.items : []);
      setNotifications(n.status === 'ready' ? n.items : []);
    })();
    return () => {
      cancelled = true;
    };
  }, [apiBaseUrl, fetchImpl]);

  if (approvals.length === 0 && notifications.length === 0) {
    return null;
  }
  return (
    <section className="cap-card cap-inbox" aria-label="งานที่รอฉันดำเนินการ" data-testid="inbox-panel">
      <h2 className="cap-notice__title">งานที่รอฉันดำเนินการ</h2>
      {notifications.length > 0 && (
        <RecordTable
          testId="inbox-notifications"
          rows={notifications}
          columns={[
            { key: 'message', label: 'เรื่อง' },
            { key: 'count', label: 'จำนวน' },
            { key: 'module_code', label: 'โมดูล' },
          ]}
        />
      )}
      {approvals.length > 0 && (
        <RecordTable
          testId="inbox-approvals"
          rows={approvals}
          columns={[
            { key: 'kind', label: 'ประเภท' },
            { key: 'reference', label: 'เอกสาร' },
            { key: 'plant_code', label: 'โรงงาน' },
            { key: 'created_by_employee_id', label: 'ผู้สร้าง' },
            { key: 'waiting_since', label: 'รอตั้งแต่' },
          ]}
          rowActions={(row) =>
            row.kind === 'TAG_COUNT_ADJUSTMENT' ? (
              <Link className="cap-button cap-button--ghost" to="/inventory/tag-count-adjustments">
                เปิดหน้าตัดสินใจ
              </Link>
            ) : null
          }
        />
      )}
    </section>
  );
}
